import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConfirmComponent } from './confirm/confirm.component';
import { SubscriberComponent } from './subscriber/subscriber.component';
import { UnsubscriberComponent } from './unsubscriber/unsubscriber.component';
import { UnsubsuccessComponent } from './unsubsuccess/unsubsuccess.component';
import { ErrorComponent } from './error/error.component';
import { SuccessComponent } from './success/success.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SmsunsubComponent } from './smsunsub/smsunsub.component';
import { SuccessunsubsmsComponent } from './successunsubsms/successunsubsms.component';
//import { CancelserviceComponent } from "./cancelservice/cancelservice.component";
import { UnsubscribeComponent } from "./unsubscribe/unsubscribe.component";

const routes: Routes = [
  { path: '', redirectTo: 'de/newsletter', pathMatch: 'full' },
  { path: 'de/newsletter', component: SubscriberComponent },
  { path: ':lang/newsletter', component: SubscriberComponent },
  { path: ':lang/abmeldung', component: UnsubscriberComponent },
  { path: ':lang/unsubscriber', component: UnsubscriberComponent },
  { path: ':lang/unsubsuccess', component: UnsubsuccessComponent },
  { path: ':lang/success', component: SuccessComponent },
  { path: ':lang/anmeldung', component: ConfirmComponent },
  { path: ':lang/smsunsub', component: SmsunsubComponent },
  { path: ':lang/successunsubsms', component: SuccessunsubsmsComponent },
  { path: ':lang/error/:message', component: ErrorComponent },
//  { path: ':lang/cancelservice', component: CancelserviceComponent },
//  http://10.2.34.11/amc-forms-web/nl/unsubscribe?id=9999999
  { path: ':lang/unsubscribe', component: UnsubscribeComponent },
//At the end
  { path: '**', component: NotFoundComponent }
];

// @ts-ignore
@NgModule({
  imports: [RouterModule.forRoot(routes, { /*relativeLinkResolution: 'legacy' */})],
  exports: [RouterModule]
})
export class AppRoutingModule { }

export const routingComponents =
  [
    SubscriberComponent,
    UnsubscriberComponent,
    ConfirmComponent,
    UnsubsuccessComponent,
    ErrorComponent,
    NotFoundComponent,
    SmsunsubComponent,
    SuccessunsubsmsComponent,
//    CancelserviceComponent,
    UnsubscribeComponent
  ]
